import { EnvironmentProviders, Provider } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { authInterceptor } from './interceptors/auth.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';
import { loadingInterceptor } from './interceptors/loading.interceptor';

export const coreProviders: Array<Provider | EnvironmentProviders> = [
  provideHttpClient(withInterceptors([authInterceptor, loadingInterceptor, errorInterceptor])),
];
